import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('AM');
    const [translations, setTranslations] = useState(null); // Start as null
    const [loading, setLoading] = useState(true); // Loading state

    useEffect(() => {
        axios.get('https://cosmo.run.am/api.php?action=getTranslation')
            .then(response => {
                setTranslations(response.data);
            })
            .catch(error => {
                console.error('Error fetching translations:', error);
            })
            .finally(() => {
                setLoading(false); // Always stop loading
            });
    }, []);

    const toggleLanguage = () => {
        setLanguage((prev) => (prev === 'EN' ? 'AM' : 'EN'));
    };

    const t = (key) => {
        if (!translations || !translations[language]) {
            return key;
        }
        return key.split('.').reduce((acc, part) => acc?.[part], translations[language]) || key;
    };

    if (loading) {
        return null; // or you can return a loader/spinner here
    }

    return (
        <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
